module.exports = ".score{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:10px 15px;position:relative}.score::after{content:'';display:block;width:100%;margin-top:10px;border-bottom:1px solid #404040}.score .content title{font-size:24px}.score .content small{color:#9e9e9e}.score .results{width:100px;text-align:right}.score .secondary{color:#9e9e9e;font-size:11px}.score .amount.sale{color:#8BC34A}.score .amount.refund{color:#E41736}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/employees/scores/score-invoices.component.scss
// module id = 809
// module chunks = 0